const eventSections = document.querySelectorAll(".events-section");

document.querySelectorAll(".menu-toggle").forEach((toggle) => {
  const menuId = toggle.getAttribute("aria-controls");
  const menu = document.getElementById(menuId);

  if (!menu) {
    return;
  }

  toggle.addEventListener("click", () => {
    const isOpen = toggle.getAttribute("aria-expanded") === "true";
    toggle.setAttribute("aria-expanded", String(!isOpen));
    toggle.setAttribute("aria-label", isOpen ? "Open menu" : "Close menu");
    menu.hidden = isOpen;
  });

  menu.querySelectorAll("a").forEach((link) => {
    link.addEventListener("click", () => {
      toggle.setAttribute("aria-expanded", "false");
      toggle.setAttribute("aria-label", "Open menu");
      menu.hidden = true;
    });
  });
});

document.querySelectorAll(".share-copy").forEach((button) => {
  button.addEventListener("click", async () => {
    const shareUrl = button.dataset.shareUrl;
    const status = button.closest(".product-share")?.querySelector(".share-status");

    if (!shareUrl) {
      return;
    }

    try {
      if (navigator.share) {
        await navigator.share({ url: shareUrl });
        if (status) status.textContent = "Shared";
      } else if (navigator.clipboard) {
        await navigator.clipboard.writeText(shareUrl);
        if (status) status.textContent = "Link copied";
      } else {
        window.prompt("Copy this product link", shareUrl);
        if (status) status.textContent = "Copy link";
      }
    } catch (error) {
      if (status) status.textContent = "";
    }
  });
});

eventSections.forEach((section) => {
  const filters = section.querySelectorAll(".filter");
  const events = section.querySelectorAll(".event-card");
  const eventDays = section.querySelectorAll(".has-event");
  const modal = section.querySelector(".rsvp-modal");
  const rsvpTitle = section.querySelector("[data-rsvp-title]");
  const eventInput = section.querySelector('input[name="contact[event]"]');
  const closeButton = section.querySelector(".close-button");

  filters.forEach((filter) => {
    filter.addEventListener("click", () => {
      const selected = filter.dataset.filter;

      filters.forEach((button) => button.classList.remove("is-active"));
      filter.classList.add("is-active");

      events.forEach((eventCard) => {
        const shouldShow = selected === "all" || eventCard.dataset.type === selected;
        eventCard.hidden = !shouldShow;
      });
    });
  });

  eventDays.forEach((day) => {
    day.addEventListener("click", () => {
      const selectedDay = Number(day.dataset.day);
      const match = Array.from(events).find((eventCard) =>
        Number(eventCard.dataset.day) === selectedDay
      );

      if (match) {
        match.scrollIntoView({ behavior: "smooth", block: "center" });
        match.animate(
          [
            { outline: "2px solid transparent" },
            { outline: "2px solid #f3c63b" },
            { outline: "2px solid transparent" }
          ],
          { duration: 1200, easing: "ease-out" }
        );
      }
    });
  });

  section.querySelectorAll(".rsvp-button").forEach((button) => {
    button.addEventListener("click", () => {
      const eventName = button.dataset.event;

      if (rsvpTitle) {
        rsvpTitle.textContent = eventName;
      }

      if (eventInput) {
        eventInput.value = eventName;
      }

      if (modal && typeof modal.showModal === "function") {
        modal.showModal();
      }
    });
  });

  if (closeButton && modal) {
    closeButton.addEventListener("click", () => modal.close());
  }
});
